import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Package, MessageSquare, FileText, Mail, Gift } from "lucide-react";
import SettingsWidget from "./SettingsWidget";

export default function AdminDashboard() {
  const [summary, setSummary] = useState(null);
  useEffect(() => { api.get("/admin/summary").then((r) => setSummary(r.data)); }, []);

  const cards = [
    { key: "products", label: "Products", icon: Package },
    { key: "quotes_new", label: "New quotes", icon: MessageSquare, highlight: true },
    { key: "quotes_total", label: "Quotes (all-time)", icon: MessageSquare },
    { key: "sample_boxes_new", label: "New sample requests", icon: Gift, highlight: true },
    { key: "sample_boxes_total", label: "Sample requests (all)", icon: Gift },
    { key: "posts", label: "Blog posts", icon: FileText },
    { key: "messages", label: "Contact messages", icon: Mail },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="eyebrow">Overview</div>
      <h1 className="font-display text-4xl text-brand-ink mt-2">Welcome back.</h1>
      <p className="text-brand-stone mt-2">A quick look at what's happening at Cake World USA.</p>

      <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {cards.map((c) => (
          <div key={c.key} data-testid={`stat-${c.key}`} className={`rounded-2xl p-5 border ${c.highlight ? "bg-brand-ink text-white border-brand-ink" : "bg-white border-brand-line"}`}>
            <c.icon className={`w-5 h-5 ${c.highlight ? "text-brand-red" : "text-brand-ink/60"}`} />
            <div className={`font-display text-4xl mt-4 ${c.highlight ? "text-white" : "text-brand-ink"}`}>
              {summary ? (summary[c.key] ?? 0) : "—"}
            </div>
            <div className={`text-xs mt-1 ${c.highlight ? "text-white/70" : "text-brand-stone"}`}>{c.label}</div>
          </div>
        ))}
      </div>

      <div className="mt-10">
        <SettingsWidget />
      </div>
    </div>
  );
}
